module.exports = __webpack_public_path__ + "img/vip-icon.01901800.gif";